import React from 'react';

const GetInTouch = ({
  title,
  description,
  contactInfo,
  image,
  gradient = 'from-purple-900 to-orange-500',
  className = ''
}) => {
  return (
    <div className={`relative isolate overflow-hidden bg-gradient-to-r ${gradient} ${className}`}>
      <div className="mx-auto max-w-7xl">
        <div className="px-6 py-16 sm:px-8 sm:py-20 lg:py-24 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          {/* Text Content */}
          <div className="max-w-xl mx-auto lg:mx-0 lg:max-w-lg">
            <h2 className="text-3xl text-center lg:text-left font-bold tracking-tight text-white sm:text-4xl">
              {title}
            </h2>
            <p className="mt-6 text-base text-center lg:text-left sm:text-lg leading-8 text-gray-100">
              {description}
            </p>
            <ul role="list" className="mt-8 sm:mt-10 space-y-4 max-w-md mx-auto lg:mx-0">
              {contactInfo.map((info, index) => (
                <li key={index} className="flex items-start gap-x-3">
                  <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-orange-500" />
                  <span className="text-sm sm:text-base text-gray-100">{info}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="relative mt-12 sm:mt-16 lg:mt-0">
            <div className="flex justify-center lg:justify-end lg:absolute lg:right-0 lg:top-1/2 lg:transform lg:-translate-y-1/2">
              <img
                src={image}
                alt="Mobile App"
                className="w-auto h-[300px] sm:h-[400px] lg:h-[500px] max-w-none object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch; 